/* global $ */
/* global moment */
/* global async */

import maprint60seconds from '../assets/media/maprint60seconds.mp4'

const isMobile = (() => {
  let check = false;
  (function (a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
        a
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4)
      )
    ) { check = true }
  })(navigator.userAgent || navigator.vendor || window.opera)
  return check
})()

window.openFullscreen = () => {
  const videoElem = document.getElementById('tutorialVideo')
  if (videoElem.requestFullscreen) {
    videoElem.requestFullscreen()
  } else if (videoElem.webkitRequestFullscreen) {
    /* Safari */
    videoElem.webkitRequestFullscreen()
  } else if (videoElem.msRequestFullscreen) {
    /* IE11 */
    videoElem.msRequestFullscreen()
  }
}

let introStarted

export default _this => {
  if (!_this) return
  console.log('renderUsers')
  console.time('renderUsers')
  if (!window.searchPrintersByUser) {
    window.searchPrintersByUser = (name, clientId) => {
      document.getElementById('printers-menu-button').click()
      _this.$store.dispatch('user/clientSelected', clientId)
      setTimeout(() => {
        window.printersTable.search(decodeURIComponent(name)).draw(false)
      }, 0)
    }
  }

  _this.columns = [
    'downloadLink',
    'created',
    'time',
    'status',
    'name',
    'email',
    // "phone",
    // "service",
    'printers',
    'localIp',
    'hostName',
    'manufacturer',
    'model',
    'os',
    'restarted',
    'version',
    'token',
    'connected'
  ]
  const { freeze } = _this.user
  const currentUser = _this.firebase.auth().currentUser
  const userCreatedTime = currentUser
    ? new Date(currentUser.metadata.creationTime)
    : null
  _this.clients.forEach(client => {
    let time, printers
    let { created, status } = client
    const computer = client.computer
    created = created
      ? moment.unix(created.seconds).unix() * 1000
      : computer
        ? userCreatedTime
          ? moment(userCreatedTime).unix() * 1000
          : null
        : null
    let version = null
    let row = {
      DT_RowId: client.snapshot.id,
      created,
      name: client.name,
      email: client.email,
      phone: client.phone,
      downloadLink: _this.downloadLink(client.snapshot.id)
    }
    if (computer) {
      let connected = false
      if (computer.time) {
        time = moment.unix(computer.time.seconds).unix() * 1000
        printers = Object.keys(
          computer.printers.filter(
            printer =>
              (printer.macAddress || (printer.parsed && printer.parsed.serialNumber)) &&
              moment.unix(printer.time.seconds).isAfter(
                moment()
                  .subtract(1, 'months')
                  .startOf('day')
              )
          )
        ).length
        // printers = computer.printersSnapshot.docs.length;
        if (moment.unix(computer.time.seconds).isAfter(_this.OLD)) {
          status = _this.t('active')
        } else {
          status = _this.t('offline')
        }
        if (computer.version) version = computer.version
        else if (computer.registry && computer.registry.Version) { version = computer.registry.Version }
        if (computer.connection) {
          connected = computer.connection.active
            ? true
            : moment.unix(computer.connection.time / 1000).fromNow()
        }
        if (['uninstalled', 'upgraded'].includes(computer.status)) {
          status = computer.status
        }
      }
      Object.assign(row, {
        localIp: computer.localIp,
        hostName: computer.hostName,
        manufacturer: computer.manufacturer,
        model: computer.model,
        os: computer.os,
        restarted: computer.lastReboot
          ? moment.unix(computer.lastReboot / 1000).unix() * 1000
          : null,
        version: version,
        token: computer.token,
        connected
      })
    }
    Object.assign(row, { time, status: _this.t(status), printers })
    _this.data.push(row)
  })
  $.each(_this.unique(_this.columns), (index, column) => {
    let title = column
    let uniqueColumn = { data: column }
    let visible = false
    switch (column) {
      case 'status':
        uniqueColumn['className'] = 'user-status-display'
        uniqueColumn['render'] = (data, type, row) => {
          let light, state
          if (row.localIp && data === 'upgraded') {
            light = '🟢'
            state = 'upgraded - waiting for scan'
          } else if (
            row.localIp &&
            row.connected === true &&
            data === 'active'
          ) {
            light = '🟢'
            state = 'online'
          } else if (
            row.localIp &&
            (row.connected === true ||
              moment(row.connected, _this.t('momentformat')).isAfter(
                _this.OLD
              )) &&
            !['active', 'uninstalled'].includes(data)
          ) {
            light = row.connected === true ? '🟠' : '🟡'
            state =
              row.connected === true
                ? 'error - please restart'
                : 'disconnected - internet required'
          } else if (
            row.localIp &&
            row.connected === false &&
            data === 'active'
          ) {
            light = '🟢'
            state = 'active'
          } else if (
            row.localIp &&
            row.connected !== true &&
            data === 'active'
          ) {
            light = '🟢'
            state = 'active'
          } else if (row.localIp && data !== 'active') {
            light = data === 'uninstalled' ? '🟤' : '🔴'
            state =
              data === 'uninstalled'
                ? 'uninstalled - setup again'
                : 'inactive - setup again'
          } else {
            light = '⚫'
            if (data === 'downloaded') {
              light = '🔵'
              state = 'downloaded - please install'
            } else if (data === 'opened') {
              light = '🟤'
              state = 'setup opened - not finished'
            } else if (data === 'installing') {
              light = '🟤'
              state = 'setup installing - not finished'
            } else if (data === 'installed') {
              light = '🟤'
              state = 'setup installed - waiting for scan'
            } else if (data === 'uninstalled') {
              light = '🟤'
              state = 'uninstalled - setup again'
            } else state = 'Please share setup link'
          }
          // <svg height="25" width="25">
          //   <circle cx="12" cy="12" r="6" stroke="black" stroke-width="1" fill="red" />
          // </svg>
          return `<span ${
            typeof row.connected === 'string'
              ? `title="Disconnected: ${row.connected}"`
              : row.connected === true
                ? 'title="Connected"'
                : row.connected === false
                  ? 'title="Disconnected"'
                  : ''
          }>${light}</span>
            <span class="user-status">${state}</span>`
        }
        visible = true
        break
      case 'printers':
        uniqueColumn['className'] = 'user-printers-button'
        uniqueColumn['render'] = (data, type, row) => {
          const encodedName = encodeURIComponent((row && row.name ? String(row.name) : '').trim()).replace(/'/g, "\\'")
          return `<div onclick="window.searchPrintersByUser('${encodedName}', '${row.DT_RowId}')"><span>${data ||
            0}</span> <span class="icon s7-print" /></div>`
        }
        visible = true
        break
      case 'localIp':
      case 'hostName':
      case 'version':
      case 'name':
      case 'manufacturer':
      case 'model':
        uniqueColumn['name'] = column
        visible = true
        break
      case 'time':
      case 'created':
      case 'restarted':
        visible = true
        uniqueColumn['render'] = (data, type, row, meta) => {
          if (type !== 'sort') {
            return data ? moment(data).fromNow() : ''
          }
          return data || ''
        }
        break
      case 'downloadLink':
        title = 'Setup Link'
        visible = true
        uniqueColumn['orderable'] = false
        uniqueColumn['className'] = 'button'
        uniqueColumn['render'] = (data, type, row, meta) => {
          const title = 'Maprint - Monitor your printers'
          const text = `Please open this link and install to computer connected with your printers network:%0a${encodeURIComponent(
            data
          )}`
          return `<div class="dropdown">
          <button class="btn btn-secondary dropdown-toggle" type="button" style="border-radius: 7px; padding: 0.7rem;" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            Share Link
          </button>
          <div class="dropdown-menu downloadLink" aria-labelledby="dropdownMenuButton">
            <a class="dropdown-item" target="_blank" href="mailto:?to=&subject=${title}&body=${text}">
              <i class="fas fa-envelope"></i> Share with Email
            </a>
            ${
  !isMobile
    ? `<a class="dropdown-item" target="_blank" onclick="window.open('https://mail.google.com/mail/?view=cm&to=&su=${title}&body=${text}', '_blank', 'location=yes,height=600,width=800,scrollbars=yes,status=yes');">
                  <i class="fab fa-gmail"></i> Share with Gmail
                </a>`
    : ''
}
            <a class="dropdown-item" target="_blank" onclick="window.open('${
  isMobile ? 'whatsapp://' : 'https://web.whatsapp.com/'
}send?text=${text}', '_blank', 'location=yes,height=600,width=800,scrollbars=yes,status=yes');">
              <i style="color: #25D366" class="fab fa-whatsapp"></i> Share with WhatsApp
            </a>
            <span class="dropdown-item copy" data-clipboard-text="${data}"><i class="fas fa-copy"></i> Copy Link</span>
          </div>
        </div>`
        }
        break
    }
    switch (column) {
      case 'time':
        title = 'Last Scan'
        uniqueColumn['className'] = 'defaultOrderBy'
        break
    }
    uniqueColumn['title'] = _this.t(title)
    uniqueColumn['visible'] = visible
    _this.uniqueColumns.push(uniqueColumn)
  })

  const currentTime = new Date().getTime()
  let { options } = _this.createTableProperties(_this)
  options = $.extend(true, options, {
    rowCallback: function (row, data) {
      const { time: rowTime } = data
      const timeDiff = currentTime - rowTime
      const hoursDiff = Math.floor(timeDiff / (1000 * 60 * 60))
      if (hoursDiff > 24) {
        $(row).addClass('not-today')
      }
    }
  })
  _this.table = $(_this.$el)
    .find('table')
    .DataTable(options)
  let fields, ajax
  fields = [
    {
      label: `${_this.t('Name')}<sup>*</sup>`,
      name: 'name'
    },
    {
      label: `${_this.t('Email')}`,
      name: 'email'
    }
  ]
  ajax = (method, url, d, success, error) => {
    let output = { data: [] }
    switch (d.action) {
      case 'create': {
        const data = d.data[0]
        data.status = null
        data.created = _this.firebase.firestore.FieldValue.serverTimestamp()
        const clients = []
        if (_this.validClient(data)) clients.push(data)
        const refs = []
        async.eachOf(
          clients,
          (client, id, callback) => {
            _this.$store.state.db
              .collection('users')
              .add(client)
              .then(ref => {
                refs.push(ref)
                client.DT_RowId = ref.id
                client.downloadLink = _this.downloadLink(ref.id)
                client.created = new Date()
                output.data.push(client)
                callback()
              })
          },
          () => {
            _this.ref
              .update({
                clients: _this.firebase.firestore.FieldValue.arrayUnion.apply(
                  this,
                  refs
                )
              })
              .then(() => {
                if (_this.clients.length === 0) {
                  setTimeout(() => {
                    const $firstClientDownload = $(
                      '#computers-section .dataTables_scrollBody table tbody tr .downloadLink'
                    )
                    _this.introSteps.push({
                      element: $firstClientDownload[0],
                      intro: `<div class="video-step-wrapper">
                      <div style="font-size: 1.2rem;padding-bottom: 10px;">
                      <button class="fullscreen-video" onclick="window.openFullscreen()">Fullscreen Video</button>
                      <span id="user-status-step" style="font-weight: bold">Download the setup file or send to user</span></div>
                      <video id="tutorialVideo" width="450" height="252" controls autoplay>
                        <source src="${maprint60seconds}" type="video/mp4">
                      </video>
                    </div>`
                    })

                    const unsubscribeUserStatus = _this.$store.state.db
                      .collection('users')
                      .doc(refs[0].id)
                      .onSnapshot(snapshot => {
                        if (snapshot.exists) {
                          const { status } = snapshot.data()
                          if (!status) return
                          if (status === 'active') {
                            unsubscribeUserStatus()
                            setTimeout(() => {
                              window.refresh()
                              const refreshInterval = setInterval(() => {
                                if (
                                  _this.$root.$children[0].$refs.topheader
                                    .isRefreshed
                                ) {
                                  clearInterval(refreshInterval)
                                  setTimeout(() => {
                                    window.intro = _this.intro
                                    const $firstClientPrintersButton = $(
                                      '#computers-section .dataTables_scrollBody table tbody tr .user-printers-button'
                                    )
                                    _this.intro.addStep({
                                      element: $firstClientPrintersButton[0],
                                      intro: `<div style="width: 380px;">Click here to check this user printers. The software automatically scan for new printers in the background and report all the information daily. Click <span class="icon s7-refresh"></span> on top to check for new data and click <span class="icon s7-plus"></span> to add more users and monitor their printers.</div>`,
                                      position: 'bottom'
                                    })
                                    _this.intro.exit()
                                    _this.intro.start().goToStep(3)
                                    // $firstClientPrintersButton.on(
                                    //   "click",
                                    //   () => {
                                    //     dataLayer.push({
                                    //       event: "introCompleted"
                                    //     });
                                    //     _this.intro.exit();
                                    //   }
                                    // );
                                  }, 1000)
                                }
                              }, 1000)
                            }, 1000)
                            return
                          }
                          let desctiption
                          switch (status) {
                            case 'downloaded':
                              desctiption = 'Open the file MaprintSetup.exe'
                              break
                            case 'opened':
                              desctiption = 'Install the setup opened'
                              break
                            case 'installing':
                              desctiption = 'Please wait while installing...'
                              break
                            case 'installed':
                              desctiption =
                                'We are looking for your printers...'
                              break
                          }
                          document.getElementById(
                            'user-status-step'
                          ).textContent = desctiption
                        }
                      })

                    _this.intro.setOptions({ steps: _this.introSteps })
                    _this.intro.start()
                    _this.intro.goToStep(2)
                  }, 100)
                }
                success(output)
              })
          }
        )
        break
      }
      case 'edit': {
        async.eachOf(
          d.data,
          (value, id, callback) => {
            value.DT_RowId = id
            const rowData = _this.table.row('#' + id).data()
            const data = $.extend({}, rowData, value)
            _this.$store.state.db
              .collection('users')
              .doc(id)
              .update({ name: data.name, email: data.email })
              .then(() => {
                if (data.service && value.service !== rowData.service) {
                  _this.$store.state.db
                    .collection('computers')
                    .doc(rowData.token)
                    .update({ service: data.service })
                }
                output.data.push(data)
                callback()
              })
          },
          error => {
            if (error) console.log(error)
            success(output)
          }
        )
        break
      }
      case 'remove': {
        const refs = []
        Object.keys(d.data).forEach(id =>
          refs.push(_this.$store.state.db.collection('users').doc(id))
        )
        _this.ref
          .update({
            clients: _this.firebase.firestore.FieldValue.arrayRemove.apply(
              this,
              refs
            )
          })
          .then(() => success(output))
        break
      }
    }
  }
  const editor = _this.createEditor(_this, fields, ajax)
  let buttons1 = []
  let buttons2 = []
  editor.on('preSubmit', function (e, o, action) {
    if (action !== 'remove') {
      const existingUserNames = _this.table
        .column('name:name')
        .data()
        .toArray()
        .map(name => name.toLowerCase())
      const company = this.field('name')
      if (!company.isMultiValue()) {
        if (!company.val()) {
          company.error(_this.t('A name must be given'))
        } else if (company.val().length > 30) {
          company.error(
            _this.t('The name length must be up to 30 characters.')
          )
        } else if (existingUserNames.includes(company.val().toLowerCase()) && action === 'create') {
          company.error(
            _this.t('The name already exists. Please choose a new name.')
          )
        }
      }
      if (this.inError()) return false
    }
    return true
  })

  if (!freeze) {
    buttons1.push({
      extend: 'create',
      editor: editor,
      text: '<span class="icon s7-plus"></span>',
      titleAttr: _this.t('Add'),
      formTitle: (editor, dt) => editor.i18n.create.title
    })
  }

  buttons1.push({
    extend: 'edit',
    editor: editor,
    text: '<span class="icon s7-pen"></span>',
    titleAttr: _this.t('Edit'),
    formTitle: (editor, dt) => editor.i18n.edit.title
  })
  buttons1.push({
    extend: 'remove',
    editor: editor,
    text: '<span class="icon s7-trash"></span>',
    titleAttr: _this.t('Remove')
  })
  _this.createButtons(_this, buttons1, buttons2)

  setTimeout(() => {
    if (_this.clients.length === 0) {
      const $createClient = $('#computers-section .buttons-create')
      _this.introSteps = [
        {
          element: $createClient[0],
          intro: _this.t('Add user to monitor its printers.')
        }
      ]
      _this.intro.setOptions({
        showBullets: false,
        exitOnOverlayClick: false,
        steps: _this.introSteps
      })
      $createClient.click(() => {
        _this.intro.exit()
        $('#DTE_Field_name').val(_this.user.name)
      })
      if (_this.user.account && _this.user.account.registered) {
        _this.intro.start()
      }
    }
    _this.$root.$on('intro-start', () => {
      if (!introStarted) {
        introStarted = true
        _this.intro.start()
      }
    })
    console.timeEnd('renderUsers')
  }, 100)
}



// WEBPACK FOOTER //
// ./src/mixins/Users.js